import { TemplateRef, ViewContainerRef } from '@angular/core';
/**
 * Directive that allows declaring a variable inside a view in Angular 2+.
 *
 * Example usage:
 * <div *ngVar="45 as variable">
 *   <span>{{variable}}</span>
 * </div>
 */
var VarDirective = /** @class */ (function () {
    function VarDirective(vcRef, templateRef) {
        this.vcRef = vcRef;
        this.templateRef = templateRef;
        this.context = {};
    }
    Object.defineProperty(VarDirective.prototype, "ngVar", {
        set: function (context) {
            this.context['$implicit'] = this.context['ngVar'] = context;
            this.updateView();
        },
        enumerable: true,
        configurable: true
    });
    VarDirective.prototype.updateView = function () {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    };
    return VarDirective;
}());
export { VarDirective };
